
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Check } from 'lucide-react';

const ToolsOverviewSection: React.FC = () => {
  return (
    <section className="section bg-white">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Onze tools om uw leadgeneratie te verbeteren</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ontdek onze complete toolkit voor effectieve B2B leadgeneratie via telemarketing
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6">
          <Card className="shadow-md hover:shadow-lg transition-shadow">
            <CardHeader>
              <CardTitle>Leadcalculator</CardTitle>
              <CardDescription>Bereken uw kansen en kosten</CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Realistische kostenschatting</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>ROI berekening</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Marktpotentieel analyse</span>
                </li>
              </ul>
            </CardContent>
          </Card>
          
          <Card className="shadow-md hover:shadow-lg transition-shadow">
            <CardHeader>
              <CardTitle>Telemarketing Scan</CardTitle>
              <CardDescription>Evalueer uw huidige aanpak</CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Gedetailleerde analyse</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Verbeterpunten identificatie</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Persoonlijk advies</span>
                </li>
              </ul>
            </CardContent>
          </Card>
          
          <Card className="shadow-md hover:shadow-lg transition-shadow">
            <CardHeader>
              <CardTitle>Lead Exchange</CardTitle>
              <CardDescription>Optimaliseer uw leadgegevens</CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Data-uitwisseling platform</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Kwaliteitscontrole</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-5 w-5 text-brand-red mt-0.5" />
                  <span>Integratie met CRM</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ToolsOverviewSection;
